/** Build blog section arrays from outline blocks. */
export function article({
  slug,
  title,
  metaDescription,
  category,
  keywords,
  publishedAt,
  readMinutes,
  blocks,
}) {
  const sections = [];
  for (const block of blocks) {
    if (block.h2) {
      sections.push({ type: "h2", text: block.h2 });
    }
    if (block.p) {
      const paras = Array.isArray(block.p) ? block.p : [block.p];
      paras.forEach((text) => sections.push({ type: "p", text }));
    }
    if (block.ul) {
      sections.push({ type: "ul", items: block.ul });
    }
  }
  return {
    slug,
    title,
    metaDescription,
    category,
    keywords: Array.isArray(keywords) ? keywords.join(", ") : keywords,
    publishedAt,
    readMinutes,
    sections,
  };
}
